import Vue from "vue";
import DashboardPlugin from "./material-dashboard";
import { store } from "./store";
import { router } from "./helpers";
// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import VueSweetalert2 from "vue-sweetalert2";
//FA
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import fontawesome from "@fortawesome/fontawesome";
import solid from "@fortawesome/fontawesome-free-solid";
import regular from "@fortawesome/fontawesome-free-regular";
import { faPoop } from "@fortawesome/free-solid-svg-icons";
import { faTintSlash } from "@fortawesome/free-solid-svg-icons";
import VueApexCharts from "vue-apexcharts";
import Notifications from "./components/NotificationPlugin";

import { MonthPicker } from "vue-month-picker";
import { MonthPickerInput } from "vue-month-picker";
import i18n from "./helpers/vue-i18n";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
Vue.component("vue-ctk-date-time-picker", VueCtkDateTimePicker);

Vue.use(MonthPicker);
Vue.use(MonthPickerInput);

Vue.component("apexchart", VueApexCharts);
Vue.use(Notifications);

fontawesome.library.add(faPoop);
fontawesome.library.add(faTintSlash);
fontawesome.library.add(solid);
fontawesome.library.add(regular);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueSweetalert2);
Vue.use(DashboardPlugin);
Vue.use(require("vue-moment"));
// global library setup
Vue.prototype.$Chartist = Chartist;



/* eslint-disable no-new */
new Vue({
    el: "#app",
    i18n,
    router,
    store,
    render: (h) => h(App),
});
